export const FETCH_END = "setArticles";
export const FETCH_START = "setLoading";
export const PURGE_AUTH = "logOut";
export const SET_ARTICLE = "setArticle";
export const SET_AUTH = "setUser";
export const SET_COMMENTS = "setComments";
export const SET_ERROR = "setError";
export const SET_PROFILE = "setProfile";
export const SET_TAGS = "setTags";
export const TAG_ADD = "addTag";
export const TAG_REMOVE = "removeTag";
export const UPDATE_ARTICLE_IN_LIST = "updateArticleInList";
export const RESET_STATE = "resetModuleState";
export const SET_REGISTER_FORM = "setRegisterForm";
export const RESET_REGISTER_FORM = "resetRegisterForm";
export const SET_PROFILE_FORM = "setProfileForm";
export const SET_PRODUCT_FORM = "setProductForm";
export const SET_PRODUCT_ADD_CART_FORM = "setProductAddCartForm";
export const SET_PRODUCT_EDIT_CART_FORM = "setProductEditCartForm";
export const SET_PRODUCT_DELETE_CART_FORM = "setProductDeleteCartForm";
export const FAVORITE_ADD_FORM = "favoreteAddSetForm";
export const FAVORITE_DELETE_FORM = "favoreteDeleteSetForm";
export const USER_ADD_FORM = "userAddForm";
export const SET_QUANTITY_CART_FORM = "quantityCartSetForm";
export const SET_TOTAL_CART_FORM = "totalCartSetForm";
export const SET_USER_ORDER_FORM = "userOrderSetForm";
export const SET_UPDATE_USER_ORDER_FORM = "updateUserOrderSetForm";
export const SET_UPDATE_ARRIVAL_DATE_ORDER_FORM =
  "updateArrivalDateOrderSetForm";
export const SET_ITEM_ORDER_FORM = "itemOrderSetForm";
export const SET_UPDATE_DISCOUNT_ORDER_FORM = "discountOrderSetForm";
export const SET_COMBINI_ORDER_FORM = "SET_COMBINI_ORDER_FORM";
export const SET_CARD_ORDER_FORM = "SET_CARD_ORDER_FORM";
export const SET_PAYMENT_ORDER_FORM = "SET_PAYMENT_ORDER_FORM";
export const SET_PRODUCT_DETAIL = "SET_PRODUCT_DETAIL";
export const SET_FORGOT_FORM = "SET_FORGOT_FORM";
export const SET_LIST_FAVORITE = "SET_LIST_FAVORITE";
export const SET_CART_ERROR = "SET_CART_ERROR";
export const SET_ERROR_FAVORITE = "SET_ERROR_FAVORITE";
export const SET_CART = "SET_CART";
export const SET_CART_LOCAL = "SET_CART_LOCAL";
export const SET_CART_LOCAL_API = "SET_CART_LOCAL_API";
export const SET_ORDER_FORM = "setOrderForm";
export const SET_PRODUCT_OPTION1 = "SET_PRODUCT_OPTION1";
export const SET_PRODUCT_OPTION2 = "SET_PRODUCT_OPTION2";
export const SET_CATEGORY_PRODUCT = "SET_CATEGORY_PRODUCT";
export const SET_CATEGORY_LIST = "SET_CATEGORY_LIST";
export const SET_ORDER_LIST = "SET_ORDER_LIST";
export const SET_ORDER_ERROR = "SET_ORDER_ERROR";
export const SET_WITHDRAWAL_ERROR = "SET_WITHDRAWAL_ERROR";
export const SET_ORDER = "SET_ORDER";
export const SET_ADDRESS_REGISTER = "SET_ADDRESS_REGISTER";
export const SET_ADDRESS_PROFILE = "SET_ADDRESS_PROFILE";
export const CLEAR_CART = "CLEAR_CART";
export const SET_NEW_PRODUCT = "SET_NEW_PRODUCT";
export const SET_PRODUCT_LIST = "SET_PRODUCT_LIST";
export const SET_LIST_GOODS = "SET_LIST_GOODS";
export const SET_ERROR_GOODS = "SET_ERROR_GOODS";
export const SET_GOOD_DETAIL = "SET_GOOD_DETAIL";
export const SET_GOOD_DETAIL_ERROR = "SET_GOOD_DETAIL_ERROR";
export const SET_ALL_ORDER = "SET_ALL_ORDER";
export const SET_ALL_GOODS = "SET_ALL_GOODS";
export const SET_ADDRESS_ZIPCODE = "SET_ADDRESS_ZIPCODE";
export const SET_ORDER_ZIPCODE = "SET_ORDER_ZIPCODE";
export const SET_RESET_ORDER_FORM = "SET_RESET_ORDER_FORM";
export const SET_SHIPPING_NOODLE = "SET_SHIPPING_NOODLE";
export const SET_SHIPPING_GOODS = "SET_SHIPPING_GOODS";
export const SET_SHIPPING_ERROR = "SET_SHIPPING_ERROR";
export const SET_QUANTITY_NOODLE = "SET_QUANTITY_NOODLE";
export const SET_QUANTITY_GOODS = "SET_QUANTITY_GOODS";
export const SET_SIZE_NOODLES_LOCAL = "SET_SIZE_NOODLES_LOCAL";
export const SET_SIZE_GOODS_LOCAL = "SET_SIZE_GOODS_LOCAL";
export const SET_CODE_CONVENIENCE_STORES_ORDER =
  "SET_CODE_CONVENIENCE_STORES_ORDER";
export const SET_PREFECTURE = "SET_PREFECTURE";
export const SET_VALID_PROMO_CODE = "SET_VALID_PROMO_CODE";
export const SET_CATEGORY_PRODUCT_LIST = "SET_CATEGORY_PRODUCT_LIST";
export const SET_ORDER_PRICE = "SET_ORDER_PRICE";
export const SET_ORDER_PRICE_PAYLOAD = "SET_ORDER_PRICE_PAYLOAD";
export const SET_RECENT_NEWS_LIST = "SET_RECENT_NEWS_LIST";
export const SET_REGISTER_TOKEN = "SET_REGISTER_TOKEN";
